const ClientEnglishFallback = {
  ClientPictureboard: (APIDATA) => {
    return {
      TEXT_PICTURE_BOARD: APIDATA?.TEXT_PICTURE_BOARD || "Picture Board",
      TEXT_ALBUMS: APIDATA?.TEXT_ALBUMS || "Albums",
      TEXT_TAB_ALL: APIDATA?.TEXT_TAB_ALL || "All",
      TEXT_MY_SUBMISSIONS: APIDATA?.TEXT_MY_SUBMISSIONS || "My Submissions",
      TEXT_IMAGE_WILL_NOT_VISIBLE:
        APIDATA?.TEXT_IMAGE_WILL_NOT_VISIBLE || "This image will not be visible to others until",
      TEXT_APPROVES_IT: APIDATA?.TEXT_APPROVES_IT || "approves it.",
      TEXT_PICTURES: APIDATA?.TEXT_PICTURES || "Pictures",
      TEXT_SELECTED_PICTURES: APIDATA?.TEXT_SELECTED_PICTURES || "Selected Pictures", //n
      TEXT_SAY_SOMETHING_ABOUT_THIS:
        APIDATA?.TEXT_SAY_SOMETHING_ABOUT_THIS || "Say something about this...",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_SUBMIT_BUTTON: APIDATA?.TEXT_SUBMIT_BUTTON || "Submit",
      BUTTON_CANCEL: APIDATA?.BUTTON_CANCEL || "Cancel",
      TEXT_NO_PICTURES_YET:
        APIDATA?.TEXT_NO_PICTURES_YET ||
        "No pictures yet. Submit a picture now to share it with your company!",
      TEXT_WHEN: APIDATA?.TEXT_WHEN || "When",
      TEXT_APPROVES_YOUR_SUBMISSION:
        APIDATA?.TEXT_APPROVES_YOUR_SUBMISSION ||
        "approves your submission, it will be displayed here for everyone to view"
    };
  },
  ClientHome: (APIDATA) => {
    return {
      TEXT_NO_PICTURE_ADDED: APIDATA.TEXT_NO_PICTURE_ADDED || "No Picture Added/Approved", //n
      TEXT_EXPENSES: APIDATA.TEXT_EXPENSES || "Expenses",
      TEXT_PENDING_APPROVAL: APIDATA.TEXT_PENDING_APPROVAL || "Pending Approval", //n
      TEXT_TIMESHEETS: APIDATA.TEXT_TIMESHEETS || "Timesheets",
      TEXT_MY_APPLICATIONS: APIDATA.TEXT_MY_APPLICATIONS || "My Applications",
      TEXT_SORT_BY: APIDATA.TEXT_SORT_BY || "Sort by",
      TEXT_EDIT_HOME: APIDATA.TEXT_EDIT_HOME || "Edit",
      TEXT_ALPHABETICAL: APIDATA.TEXT_ALPHABETICAL || "alphabetical",
      TEXT_RECENTLY_USED: APIDATA.TEXT_RECENTLY_USED || "recently used",
      TEXT_NO_LICENSES_FOUND: APIDATA.TEXT_NO_LICENSES_FOUND || "No Licenses Found",
      // BUTTON_EDIT: APIDATA.BUTTON_EDIT || 'Edit',
      TEXT_PICTURE_BOARD: APIDATA.TEXT_PICTURE_BOARD || "Picture Board"
    };
  },
  ClientHomeEditModal: (APIDATA) => {
    return {
      TEXT_PIN_APPLICATIONS:
        APIDATA.TEXT_PIN_APPLICATIONS ||
        "Pin your most used applications to quickly access them from the Homepage."
    };
  },
  ClientHeader: (APIDATA) => {
    return {
      TEXT_HOME: APIDATA?.TEXT_HOME || "Home",
      TEXT_PICTURE_BOARD: APIDATA.TEXT_PICTURE_BOARD || "Picture Board",
      TEXT_ACTIONS: APIDATA?.TEXT_ACTIONS || "Actions",
      TEXT_CHANGE_TRACKER: APIDATA?.TEXT_CHANGE_TRACKER || "Change Tracker",
      TEXT_COACHING: APIDATA?.TEXT_COACHING || "Coaching",
      TEXT_COMMUNICATOR: APIDATA?.TEXT_COMMUNICATOR || "Communicator",
      TEXT_EQUIPMENT_INSPECTIONS: APIDATA?.TEXT_EQUIPMENT_INSPECTIONS || "Equipment Inspections",
      TEXT_INSPECTIONS: APIDATA?.TEXT_INSPECTIONS || "Inspections",
      TEXT_EXPENSES: APIDATA?.TEXT_EXPENSES || "Expenses",
      TEXT_SAFETY_INCIDENTS: APIDATA?.TEXT_SAFETY_INCIDENTS || "Safety Incidents",
      TEXT_SAFETY_OBSERVATIONS: APIDATA?.TEXT_SAFETY_OBSERVATIONS || "Safety Observations",
      TEXT_SITE_ACTIVITY_REPORTS: APIDATA?.TEXT_SITE_ACTIVITY_REPORTS || "Site Activity Reports", //n
      TEXT_SITE_ESTIMATES: APIDATA?.TEXT_SITE_ESTIMATES || "Site Estimates", //n
      TEXT_SITE_FILING: APIDATA?.TEXT_SITE_FILING || "Site Filing",
      TEXT_SUPPORT_REQUESTS: APIDATA?.TEXT_SUPPORT_REQUESTS || "Support Requests", //n
      TEXT_TAKE5: APIDATA.TEXT_TAKE5 || "Take 5",
      TEXT_PLACEHOLDER_GLOBAL: APIDATA.TEXT_PLACEHOLDER_GLOBAL || "Search records",
      TEXT_TIMESHEETS: APIDATA?.TEXT_TIMESHEETS || "Timesheets",
      TEXT_VIDEOS_TITLE: APIDATA.TEXT_VIDEOS_TITLE || "Videos",
      TEXT_QUALITY_CONTROL: APIDATA?.TEXT_QUALITY_CONTROL || "Quality Control",
      TEXT_CLIENT_CHAT_2: APIDATA?.TEXT_CLIENT_CHAT_2 || "Chat",
      TEXT_CLIENT_NOTIFICATIONS: APIDATA?.TEXT_CLIENT_NOTIFICATIONS || "Client Notifications"
    };
  },

  ClientTakeFive: (APIDATA) => {
    return {
      TEXT_NO_REPORT: APIDATA.TEXT_NO_REPORT || "No report available", //SAME AS NATIVE
      TEXT_SEE_MORE: APIDATA?.TEXT_SEE_MORE || "See More",
      TEXT_SEE: APIDATA?.TEXT_SEE || "See",
      TEXT_MORE: APIDATA?.TEXT_MORE || "More",
      TEXT_NO_JOBS_AVAILABLE: APIDATA?.TEXT_NO_JOBS_AVAILABLE || "No Jobs Available"
    };
  },
  ClientTakeFiveAddModel: (APIDATA) => {
    return {
      TEXT_MICROPHONE_ACCESS_ERROR:
        APIDATA?.TEXT_MICROPHONE_ACCESS_ERROR || "Microphone access is required for recording",
      TEXT_RECORDING_ERROR: APIDATA?.TEXT_RECORDING_ERROR || "Recording error:",
      TEXT_UNKOWN_ERROR: APIDATA?.TEXT_UNKOWN_ERROR || "Unknown error",
      TEXT_ALLOW_MICROPHONE:
        APIDATA?.TEXT_ALLOW_MICROPHONE || "Please allow microphone access in your browser settings",
      TEXT_INVALID_DATA: APIDATA?.TEXT_INVALID_DATA || "Invalid recording data",
      TEXT_PROCESSING_ERROR: APIDATA?.TEXT_PROCESSING_ERROR || "Error processing audio",
      TEXT_ERROR_READING_AUDIO: APIDATA?.TEXT_ERROR_READING_AUDIO || "Error reading audio data",
      TEXT_CONVERTING_ERROR: APIDATA?.TEXT_CONVERTING_ERROR || "Error converting recording",
      TEXT_NO_VALID_RECORDING: APIDATA?.TEXT_NO_VALID_RECORDING || "No valid recording to save",
      TEXT_FAILED_TO_SAVE: APIDATA?.TEXT_FAILED_TO_SAVE || "Failed to save recording",
      TEXT_FAILED_TO_START: APIDATA?.TEXT_FAILED_TO_START || "Failed to start recording",
      TEXT_CHECK_SURROUNDING: APIDATA?.TEXT_CHECK_SURROUNDING || "1. Check surrounding area",
      TEXT_INPUT_TIMESHEET: APIDATA?.TEXT_INPUT_TIMESHEET || "2. Input timesheet",
      TEXT_CHECK_WHETHER: APIDATA?.TEXT_CHECK_WHETHER || "3. Check weather",
      TEXT_REPORT_DANGER: APIDATA?.TEXT_REPORT_DANGER || "4. Report any immediate danger",
      TEXT_MICROPHONE_PERMISSION:
        APIDATA?.TEXT_MICROPHONE_PERMISSION || "Microphone permission required",
      TEXT_RECORD_MESSAGE: APIDATA?.TEXT_RECORD_MESSAGE || "Record a message",
      TEXT_PAUSING_ERROR: APIDATA?.TEXT_PAUSING_ERROR || "Error pausing recording",
      TEXT_RESUMEING_ERROR: APIDATA?.TEXT_RESUMEING_ERROR || "Error resuming recording",
      TEXT_ERROR_STOPPING: APIDATA?.TEXT_ERROR_STOPPING || "Error stopping recording",
      TEXT_ERROR_PLAYING: APIDATA?.TEXT_ERROR_PLAYING || "Error playing recording",
      TEXT_SAVE_BTN: APIDATA?.TEXT_SAVE_BTN || "Save"
    };
  },
  ClientVideos: (APIDATA) => {
    return {
      TEXT_NO_VIDEOS: APIDATA?.TEXT_NO_VIDEOS || "No Videos.",
      TEXT_MORE_VIDEOS: APIDATA?.TEXT_MORE_VIDEOS || "More Videos"
    };
  },
  ClientSiteEstimates: (APIDATA) => {
    return {
      //same as native
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_AREA_ITEM: APIDATA?.TEXT_AREA_ITEM || "Area/Item",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_DAYS: APIDATA?.TEXT_DAYS || "Days",
      TEXT_EMPLOYEES: APIDATA?.TEXT_EMPLOYEES || "Employees",
      TEXT_SUB_TOTAL: APIDATA?.TEXT_SUB_TOTAL || "Subtotal",
      TEXT_END_MESSAGE: APIDATA?.TEXT_END_MESSAGE || "No more estimates to load",
      TEXT_NO_ESTIMATE: APIDATA?.TEXT_NO_ESTIMATE || "No estimates found"
    };
  },
  ClientEstimateAddModal: (APIDATA) => {
    return {
      //same as native
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_DAYS: APIDATA?.TEXT_DAYS || "Days",
      TEXT_EMPLOYEES: APIDATA?.TEXT_EMPLOYEES || "Employees",
      TEXT_SUB_TOTAL: APIDATA?.TEXT_SUB_TOTAL || "Subtotal",
      TEXT_SUBMIT: APIDATA?.TEXT_SUBMIT || "Submit",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_PLACEHOLDER_SEARCH_JOB: APIDATA?.TEXT_PLACEHOLDER_SEARCH_JOB || "Search for a Job",
      TEXT_NO_JOB: APIDATA?.TEXT_NO_JOB || "No job found.",
      TEXT_JOBS: APIDATA?.TEXT_JOBS || "Jobs",
      TEXT_AREA_ITEM: APIDATA?.TEXT_AREA_ITEM || "Area/Item",
      TEXT_ADD_ITEM: APIDATA?.TEXT_ADD_ITEM || "Add Item",
      TEXT_CREATE_ESTIMATE: APIDATA?.TEXT_CREATE_ESTIMATE || "Create Estimate" //added as new key
    };
  },
  ClientSAR: (APIDATA) => {
    return {
      TEXT_NO_REPORT: APIDATA?.TEXT_NO_REPORT || "No report available", //same as native
      TEXT_SEE_MORE: APIDATA?.TEXT_SEE_MORE || "See more",
      TEXT_NO_DATA: APIDATA?.TEXT_NO_DATA || "No data"
    };
  },
  ClientSARViewModal: (APIDATA) => {
    return {
      //same as native
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_DATE: APIDATA?.TEXT_DATE || "Date",
      TEXT_TIME: APIDATA?.TEXT_TIME || "Time",
      TEXT_OBSERVATION: APIDATA?.TEXT_OBSERVATION || "Observations",
      TEXT_NOTES: APIDATA?.TEXT_NOTES || "Notes",
      TEXT_TAB_ACTIONS: APIDATA?.TEXT_TAB_ACTIONS || "Actions",
      TEXT_ADD_NOTE: APIDATA?.TEXT_ADD_NOTE || "Add Note",
      TEXT_ADD_OBSERVATION: APIDATA?.TEXT_ADD_OBSERVATION || "Add Observation",
      TEXT_ADD_ACTION: APIDATA?.TEXT_ADD_ACTION || "Add Action",
      TEXT_REPORT_DONT_HAVE_ACTION:
        APIDATA?.TEXT_REPORT_DONT_HAVE_ACTION || "This Report does not have any Actions.",
      TEXT_DUE: APIDATA?.TEXT_DUE || "Due",
      //added as new key
      TEXT_REPORT_DONT_HAVE_ANY_NOTES:
        APIDATA?.TEXT_REPORT_DONT_HAVE_ANY_NOTES || "This Report does not have any Notes.",
      TEXT_REPORT_DONT_HAVE_OBSERVATION:
        APIDATA?.TEXT_REPORT_DONT_HAVE_OBSERVATION || "This Report does not have any Observations."
    };
  },
  ClientSARAddModal: (APIDATA) => {
    return {
      //same as native
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_DATE: APIDATA?.TEXT_DATE || "Date",
      TEXT_TIME: APIDATA?.TEXT_TIME || "Time",
      TEXT_WEATHER: APIDATA?.TEXT_WEATHER || "Weather",
      TEXT_REPORT_CAN_BE_EDITED_WITHIN:
        APIDATA?.TEXT_REPORT_CAN_BE_EDITED_WITHIN || "Reports can only be edited within 48 hours.",
      TEXT_CREATE_REPORT: APIDATA?.TEXT_CREATE_REPORT || "Create Report"
    };
  },
  ClientNotesAddModal: (APIDATA) => {
    return {
      //same as native
      TEXT_TYPE: APIDATA?.TEXT_TYPE || "Type",
      TEXT_SELECT_TYPE: APIDATA?.TEXT_SELECT_TYPE || "Select Type",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_TYPE_SOMETHING: APIDATA?.TEXT_TYPE_SOMETHING || "Type Something...",
      TEXT_SAVE: APIDATA?.TEXT_SAVE || "Save"
    };
  },
  ClientSARActionsAddModel: (APIDATA) => {
    return {
      //same as native
      TEXT_EMPLOYEE: APIDATA?.TEXT_EMPLOYEE || "Employee",
      TEXT_SEARCH_EMPLOYEE: APIDATA?.TEXT_SEARCH_EMPLOYEE || "Search for an Employee",
      TEXT_TITLE: APIDATA?.TEXT_TITLE || "Title",
      TEXT_ENTER_TITLE: APIDATA?.TEXT_ENTER_TITLE || "Enter a title",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_DESCRIPTION_PLACEHOLDER: APIDATA?.TEXT_DESCRIPTION_PLACEHOLDER || "Describe the action",
      TEXT_DUE: APIDATA?.TEXT_DUE || "Due",
      TEXT_CHOOSE_DATE: APIDATA?.TEXT_CHOOSE_DATE || "Choose a date",
      TEXT_SAVE: APIDATA?.TEXT_SAVE || "Save"
    };
  },

  ClientChangeTracker: (APIDATA) => {
    return {
      TEXT_NO_DATA: APIDATA?.TEXT_NO_DATA || "No data",
      TEXT_SEE_MORE: APIDATA?.TEXT_SEE_MORE || "See More",
      TEXT_NO_REQUEST_AVAILABLE: APIDATA?.TEXT_NO_REQUEST_AVAILABLE || "No request available"
    };
  },
  ClientChangeTrackerAddModel: (APIDATA) => {
    return {
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_DATE: APIDATA?.TEXT_DATE || "Date",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_CHANGE_IS_REQUIRED:
        APIDATA?.TEXT_CHANGE_IS_REQUIRED || "Describe what change is required",
      TEXT_SUBMIT: APIDATA?.TEXT_SUBMIT || "Submit"
    };
  },
  ClientChangeTrackerViewModel: (APIDATA) => {
    return {
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_ME: APIDATA?.TEXT_ME || "me"
    };
  },

  ClientCoaching: (APIDATA) => {
    return {
      TEXT_RECEIVED: APIDATA?.TEXT_RECEIVED || "Received",
      TEXT_SUBMITTED: APIDATA?.TEXT_SUBMITTED || "Submitted",
      TEXT_SUBMITTED_ANONYMOUSLY: APIDATA?.TEXT_SUBMITTED_ANONYMOUSLY || "Submitted anonymously",
      TEXT_EMPTY_RECEIVED:
        APIDATA?.TEXT_EMPTY_RECEIVED || "You do not have any received Coaching Requests.",
      TEXT_EMPTY_SUBMITTED:
        APIDATA?.TEXT_EMPTY_SUBMITTED || "You have not submitted any Coaching Requests."
    };
  },
  ClientCoachingAddModal: (APIDATA) => {
    return {
      TEXT_EMPLOYEE: APIDATA?.TEXT_EMPLOYEE || "Employee",
      TEXT_COACHINGFORM_PLACEHOLDER_FIRST:
        APIDATA?.TEXT_COACHINGFORM_PLACEHOLDER_FIRST || "Search for an Employee",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_COACHINGFORM_PLACEHOLDER_SECOND:
        APIDATA?.TEXT_COACHINGFORM_PLACEHOLDER_SECOND || "Describe what coaching is required.",
      TEXT_SUBMIT_ANONYMOUSLY: APIDATA?.TEXT_SUBMIT_ANONYMOUSLY || "Submit anonymously",
      TEXT_SUBMIT: APIDATA?.TEXT_SUBMIT || "Submit",
      TEXT_NO_EMPLOYEE_FOUND: APIDATA?.TEXT_NO_EMPLOYEE_FOUND || "No Employee Found."
    };
  },

  ClientCommunicator: (APIDATA) => {
    return {
      TEXT_ALL: APIDATA?.TEXT_ALL || "All",
      TEXT_TO_ACKNOWLEDGE: APIDATA?.TEXT_TO_ACKNOWLEDGE || "To Acknowledge",
      TEXT_ACKNOWLEDGED: APIDATA?.TEXT_ACKNOWLEDGED || "Acknowledged",
      TEXT_NO_MASSAGES: APIDATA?.TEXT_NO_MASSAGES || "No messages.",
      TEXT_FILTER_BY_TAG: APIDATA?.TEXT_FILTER_BY_TAG || "Filter by tag",
      TEXT_SELECTED_TAG: APIDATA?.TEXT_SELECTED_TAG || "Selected tag",
      TEXT_ALL_TAGS: APIDATA?.TEXT_ALL_TAGS || "All",
      TEXT_CANCEL: APIDATA?.TEXT_CANCEL || "Cancel",
      TEXT_TAG_FILTER_TITLE: APIDATA?.TEXT_TAG_FILTER_TITLE || "Choose a tag to filter messages",
      TEXT_TAG_FILTER_SUBTITLE:
        APIDATA?.TEXT_TAG_FILTER_SUBTITLE ||
        "Pick one of the employee tags or keep all messages visible.",
      TEXT_NO_TAGS_AVAILABLE: APIDATA?.TEXT_NO_TAGS_AVAILABLE || "No tags available."
    };
  },
  ClientCommunicatorViewModal: (APIDATA) => {
    return {
      TEXT_ACKNOWLEDGE: APIDATA?.TEXT_ACKNOWLEDGE || "Acknowledge",
      TEXT_ACKNOWLEDGED: APIDATA?.TEXT_ACKNOWLEDGED || "Acknowledged"
    };
  },

  AddEquipmentInspections: (APIDATA) => {
    return {
      TEXT_SNACKBAR_INVALID_MSG:
        APIDATA?.TEXT_SNACKBAR_INVALID_MSG || "All fields must be completed before submitting.",
      TEXT_SNACKBAR_SUCCESS:
        APIDATA?.TEXT_SNACKBAR_SUCCESS || "Inspection from Submitted Successfulyy.!",
      TEXT_SNACKBAR_FAILED:
        APIDATA?.TEXT_SNACKBAR_FAILED || "Submission failed. Ensure all fields are complete.",
      TEXT_CANNOT_EDIT: APIDATA?.TEXT_CANNOT_EDIT || "Submitted inspections cannot be edited.",
      TEXT_SUBMIT: APIDATA?.TEXT_SUBMIT || "Submit"
    };
  },
  EquipmentInspections: (APIDATA) => {
    return {
      TEXT_NEW_INSPECTION: APIDATA?.TEXT_NEW_INSPECTION || "New Inspection",
      TEXT_LOADING_INSPECTIONS: APIDATA?.TEXT_LOADING_INSPECTIONS || "Loading inspections",
      TEXT_NO_INSPECTIONS_TITLE: APIDATA?.TEXT_NO_INSPECTIONS_TITLE || "No inspections yet",
      TEXT_LABEL_DATE: APIDATA?.TEXT_LABEL_DATE || "Date",
      TEXT_LABEL_JOB: APIDATA?.TEXT_LABEL_JOB || "Job",
      TEXT_LABEL_ASSET_CODE: APIDATA?.TEXT_LABEL_ASSET_CODE || "Asset Code",
      TEXT_LABEL_EQUIPMENT_CODE:
        APIDATA?.TEXT_LABEL_EQUIPMENT_CODE || "Equipment Code",
      TEXT_STATUS_SUBMITTED: APIDATA?.TEXT_STATUS_SUBMITTED || "Submitted",
      TEXT_STATUS_DRAFT: APIDATA?.TEXT_STATUS_DRAFT || "Draft",
      TEXT_NO_JOB_SELECTED: APIDATA?.TEXT_NO_JOB_SELECTED || "No job selected",
      TEXT_NO_INSPECTION:
        APIDATA?.TEXT_NO_INSPECTION ||
        "Perform digital equipment inspections and easily submit them to",
      TEXT_NO_INSPECTION_SECOND:
        APIDATA?.TEXT_NO_INSPECTION_SECOND ||
        "has not set up any inspection forms. Contact your BuildID administrator."
    };
  },
  GeneralComponentStatic: (APIDATA) => {
    return {
      TEXT_GENERAL_COMPONENT: APIDATA?.TEXT_GENERAL_COMPONENT || "General",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_EQUIPMENT: APIDATA?.TEXT_EQUIPMENT || "Equipment",
      TEXT_ASSET_CODE: APIDATA?.TEXT_ASSET_CODE || "Asset Code",
      TEXT_SELECT_JOB: APIDATA?.TEXT_SELECT_JOB || "Select a Job(optional)",
      TEXT_ENTER_EQUIPMENT_NUMBER:
        APIDATA?.TEXT_ENTER_EQUIPMENT_NUMBER || "Enter equipment number (optional)",
      TEXT_ENTER_ASSET_CODE: APIDATA?.TEXT_ENTER_ASSET_CODE || "Enter asset code (optional)",
      TEXT_COMMENTS: APIDATA?.TEXT_COMMENTS || "Comments",
      TEXT_COMMENTS_INFO:
        APIDATA?.TEXT_COMMENTS_INFO || "Equipment number(s), notes, etc. (optional)",
      TEXT_SEARCH_JOBS: APIDATA?.TEXT_SEARCH_JOBS || "Search for a Job",
      TEXT_NO_JOB: APIDATA?.TEXT_NO_JOB || "No Job Found.",
      TEXT_SELECT_A_JOB: APIDATA?.TEXT_SELECT_A_JOB || "Select a Job"
    };
  },
  InspectionSection: (APIDATA) => {
    return {
      TEXT_ADD_PICTURES: APIDATA?.TEXT_ADD_PICTURES || "Add pictures ",
      TEXT_INSPECTION: APIDATA?.TEXT_INSPECTION || "Inspection ",
      TEXT_LOADING_DATA: APIDATA?.TEXT_LOADING_DATA || "Loading data... ",
      TEXT_NO_FORM_ITEMS:
        APIDATA?.TEXT_NO_FORM_ITEMS || "No Form Item Available for this Inspection.!",
      TEXT_YES: APIDATA?.TEXT_YES || "YES",
      TEXT_NO: APIDATA?.TEXT_NO || "NO",
      TEXT_NA: APIDATA?.TEXT_NA || "N/A"
    };
  },
  ClientChat: (APIDATA) => {
    return {
      TEXT_MESSAGES: APIDATA?.TEXT_MESSAGES || "Messages",
      TEXT_TYPE_A_MESSAGE: APIDATA?.TEXT_TYPE_A_MESSAGE || "Type a message...",
      TEXT_SEARCH_CONVERSATIONS: APIDATA?.TEXT_SEARCH_CONVERSATIONS || "Search conversations...",
      TEXT_NO_CONVERSATIONS_FOUND: APIDATA?.TEXT_NO_CONVERSATIONS_FOUND || "No conversations found",
      TEXT_WELCOME_TO_MESSAGES: APIDATA?.TEXT_WELCOME_TO_MESSAGES || "Welcome to Messages",
      TEXT_CONNECT_AND_CHAT: APIDATA?.TEXT_CONNECT_AND_CHAT || "Connect and chat with your friends",
      TEXT_SELECT_A_CONVERSATION:
        APIDATA?.TEXT_SELECT_A_CONVERSATION ||
        "Select a conversation from the sidebar or start a new chat to begin messaging",
      TEXT_PLEASE_CONTACT_CLIENT:
        APIDATA?.TEXT_PLEASE_CONTACT_CLIENT ||
        "Please contact Client Administration to create groups."
    };
  },
  ClientSupport: (APIDATA) => {
    return {
      // TEXT_SUPPORT_TITLE: APIDATA?.TEXT_SUPPORT_TITLE || 'Support',
      // TEXT_SEARCH_SUPPORT_REQUESTS_PLACE_HOLDER: APIDATA?.TEXT_SEARCH_SUPPORT_REQUESTS_PLACE_HOLDER || "--Search Support Requests",
      TEXT_SEARCH_NO_SUPPORT_REQUESTS_PLACE_HOLDER:
        APIDATA?.TEXT_SEARCH_NO_SUPPORT_REQUESTS_PLACE_HOLDER || "No Support Requests.",
      TEXT_ALL: APIDATA?.TEXT_ALL || "All",
      TEXT_OPEN: APIDATA?.TEXT_OPEN || "Open",
      TEXT_COMPLETED: APIDATA?.TEXT_COMPLETED || "Completed",
      TEXT_CLOSED: APIDATA?.TEXT_CLOSED || "Closed"
    };
  },

  AddClientSupport: (APIDATA) => {
    return {
      TEXT_DESCRIPTION_LABEL: APIDATA?.TEXT_DESCRIPTION_LABEL || "Description",
      TEXT_DESCRIBE_THE_PROBLEM_PLACE_HOLDER:
        APIDATA?.TEXT_DESCRIBE_THE_PROBLEM_PLACE_HOLDER ||
        "Describe the problem and what needs to be done",
      TEXT_URGENCY_LABEL: APIDATA?.TEXT_URGENCY_LABEL || "Urgency",
      TEXT_SELECT_OPTION_PLACE_HOLDER: APIDATA?.TEXT_SELECT_OPTION_PLACE_HOLDER || "Select option",
      TEXT_EXPECTED_COMPLETION_DATE_LABEL:
        APIDATA?.TEXT_EXPECTED_COMPLETION_DATE_LABEL || "Expected Completion Date",
      TEXT_CATEGORY_LABEL: APIDATA?.TEXT_CATEGORY_LABEL || "Category",
      TEXT_SELECT_CATEGORY_PLACE_HOLDER:
        APIDATA?.TEXT_SELECT_CATEGORY_PLACE_HOLDER || "Select category (optional)",
      TEXT_CHOOSE_A_DATE: APIDATA?.TEXT_CHOOSE_A_DATE || "Choose a date (optional)",
      BUTTON_SUBMIT: APIDATA?.BUTTON_SUBMIT || "Submit"
    };
  },

  ViewClientSupport: (APIDATA) => {
    return {
      TEXT_CLOSE_THIS_SUPPORT_REQUEST_TO_LET:
        APIDATA?.TEXT_CLOSE_THIS_SUPPORT_REQUEST_TO_LET || "Close this Support Request to let",
      TEXT_KNOW_THAT_YOUR_ISSUE_HAS_BEEN_RESOLVED:
        APIDATA?.TEXT_KNOW_THAT_YOUR_ISSUE_HAS_BEEN_RESOLVED ||
        "know that your issue has been resolved.",
      TEXT_IF_YOU_REQUIRE_FURTHER_SUPPORT_YOU_CAN_RE_OPEN_THIS_REQUEST:
        APIDATA?.TEXT_IF_YOU_REQUIRE_FURTHER_SUPPORT_YOU_CAN_RE_OPEN_THIS_REQUEST ||
        "If you require further support, you can re-open this request.",
      BUTTON_OK: APIDATA?.BUTTON_OK || "OK",
      TEXT_URGENCY: APIDATA?.TEXT_URGENCY || "Urgency",
      TEXT_EXPECTED_COMPLETION_DATE:
        APIDATA?.TEXT_EXPECTED_COMPLETION_DATE || "Expected Completion Date",
      TEXT_STATUS: APIDATA?.TEXT_STATUS || "Status",
      TEXT_WRITE_A_COMMENT_PLACE_HOLDER:
        APIDATA?.TEXT_WRITE_A_COMMENT_PLACE_HOLDER || "Write a comment",
      TEXT_NO_DATA_FROM_THE_API: APIDATA?.TEXT_NO_DATA_FROM_THE_API || "No Data From the Api",
      TEXT_RE_OPEN_REQUEST: APIDATA?.TEXT_RE_OPEN_REQUEST || "Re-open Request",
      TEXT_CLOSE_REQUEST: APIDATA?.TEXT_CLOSE_REQUEST || "Close Request",
      TEXT_ME: APIDATA?.TEXT_ME || "(me)"
    };
  },
  ClientSiteFiling: (APIDATA) => {
    return {
      TEXT_WHEN: APIDATA?.TEXT_WHEN || "When",
      TEXT_ADDS_JOB: APIDATA?.TEXT_ADDS_JOB || "adds you to a Job, they will appear here."
    };
  },
  ClientSiteFilingFolder: (APIDATA) => {
    return {
      TEXT_TYPE: APIDATA?.TEXT_TYPE || "Type",
      TEXT_NAME: APIDATA?.TEXT_NAME || "Name",
      TEXT_UPLOAD_DATE: APIDATA?.TEXT_UPLOAD_DATE || "Upload date",
      TEXT_ITEMS: APIDATA?.TEXT_ITEMS || "items",
      TEXT_SORT: APIDATA?.TEXT_SORT || "Sort by :"
    };
  },
  ClientSiteFilingAddModel: (APIDATA) => {
    return {
      TEXT_UPLOADED_FILES:
        APIDATA?.TEXT_UPLOADED_FILES ||
        "Uploaded files and descriptions cannot be edited after submitting.",
      TEXT_AS_WELL:
        APIDATA?.TEXT_AS_WELL ||
        "Items will be shared with Thermal Systems as well as any other Employees on this Job.",
      BUTTON_SUBMIT: APIDATA?.BUTTON_SUBMIT || "Submit",
      TEXT_ADD_FILES: APIDATA?.TEXT_ADD_FILES || "Add Files",
      TEXT_SAY_SOMETHING: APIDATA?.TEXT_SAY_SOMETHING || "Say something about this (optional)",
      TEXT_NO_PREVIEW: APIDATA?.TEXT_NO_PREVIEW || "No preview available.",
      TEXT_UPLOAD_FILES: APIDATA?.TEXT_UPLOAD_FILES || "Upload files",
      BUTTON_DONE: APIDATA?.BUTTON_DONE || "Done"
    };
  },
  OtherFileViewer: (APIDATA) => {
    return {
      TEXT_NO_PREVIEW: APIDATA?.TEXT_NO_PREVIEW || "No preview available.",
      BUTTON_OPEN: APIDATA?.BUTTON_OPEN || "Open"
    };
  },
  VideoViewer: (APIDATA) => {
    return {
      TEXT_YOUR_BROWSER_DOES_NOT_SUPPORT_THE_VIDEO_TAG:
        APIDATA?.TEXT_YOUR_BROWSER_DOES_NOT_SUPPORT_THE_VIDEO_TAG ||
        "Your browser does not support the video tag."
    };
  },
  SafetyObservations: (APIDATA) => {
    return {
      TEXT_ALL: APIDATA?.TEXT_ALL || "All",
      TEXT_MY_OBSERVATION: APIDATA?.TEXT_MY_OBSERVATION || "My Observations",
      TEXT_NO_OBSERVATIONS: APIDATA?.TEXT_NO_OBSERVATIONS || "No  Observations found."
    };
  },
  ClientSafetyObservationAddModal: (APIDATA) => {
    return {
      TEXT_DATE: APIDATA?.TEXT_DATE || "Date",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_PROBLEM_NEEDS_DONE:
        APIDATA?.TEXT_PROBLEM_NEEDS_DONE || "Describe the problem and what needs to be done.",
      BUTTON_SUBMIT: APIDATA?.BUTTON_SUBMIT || "Submit",
      TEXT_SEARCH_JOB: APIDATA?.TEXT_SEARCH_JOB || "Search for a Job"
    };
  },
  ClientSafetyObservationViewModal: (APIDATA) => {
    return {
      TEXT_ME: APIDATA?.TEXT_ME || "(me)",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job"
    };
  },

  ClientAddExpenses: (APIDATA) => {
    return {
      TEXT_DATE: APIDATA?.TEXT_DATE || "Date",
      TEXT_TITLE: APIDATA?.TEXT_TITLE || "Title",
      TEXT_TITLE_PLACEHOLDER: APIDATA?.TEXT_TITLE_PLACEHOLDER || "Enter Title",
      TEXT_CODE: APIDATA?.TEXT_CODE || "Code",
      TEXT_SELECT_CODE: APIDATA?.TEXT_SELECT_CODE || "Select Code",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_AMOUNT: APIDATA?.TEXT_AMOUNT || "Amount",
      TEXT_IN_REVIEW: APIDATA?.TEXT_AMOUNT || "In Review",
      TEXT_TOTAL: APIDATA?.TEXT_TOTAL || "Total",
      TEXT_TAX_OPTIONAL: APIDATA?.TEXT_TAX_OPTIONAL || "Tax (optional)",
      TEXT_TIP_OPTIONAL: APIDATA?.TEXT_TIP_OPTIONAL || "Tip (optional)",
      TEXT_SELECT1: APIDATA?.TEXT_SELECT1 || "Select 1",
      TEXT_PAID_WITH_COMPANY: APIDATA?.TEXT_PAID_WITH_COMPANY || "Paid with company card",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_PAID_PERSONALLY: APIDATA?.TEXT_PAID_PERSONALLY || "Paid Personally",

      TEXT_INCLUDE_ADDTITIONAL_DETAIL:
        APIDATA?.TEXT_INCLUDE_ADDTITIONAL_DETAIL || "include additional details, etc.",
      TEXT_UPLOAD_RECEIPT: APIDATA?.TEXT_UPLOAD_RECEIPT || "Upload Receipt",
      TEXT_SUBMIT: APIDATA?.TEXT_SUBMIT || "Submit",
      TEXT_MILEAGE: APIDATA?.TEXT_MILEAGE || "Mileage",
      TEXT_SUB_TOTAL: APIDATA?.TEXT_SUB_TOTAL || "Subtotal"
    };
  },

  ClientViewExpenses: (APIDATA) => {
    return {
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_DISTANCE: APIDATA?.TEXT_DISTANCE || "Distance",
      TEXT_TAXES: APIDATA?.TEXT_TAXES || "Taxes",
      TEXT_TIPS: APIDATA?.TEXT_TIPS || "Tip",
      TEXT_TOTAL: APIDATA?.TEXT_TOTAL || "Total",
      TEXT_PAID_PERSONALLY: APIDATA?.TEXT_PAID_PERSONALLY || "Paid personally",
      TEXT_PAID_CARD: APIDATA?.TEXT_PAID_CARD || "Paid with company card",
      TEXT_RECEIPTS: APIDATA?.TEXT_RECEIPTS || "Receipts",
      TEXT_REAJECTED_ON: APIDATA?.TEXT_REJECTED_ON || "Rejected on",
      TEXT_APPROVED_ON: APIDATA?.TEXT_APPORED_ON || "Approved on",
      TEXT_DELETE_EXPENSE_1: APIDATA?.TEXT_DELETE_EXPENSE_1 || "Delete Expense",
      TEXT_VIEW_DELETE: APIDATA?.TEXT_VIEW_DELETE || "Delete",
      TEXT_DELETE_EXPENSE:
        APIDATA?.TEXT_DELETE_EXPENSE || "Are you sure you want to delete this Expense?",
      TEXT_SUBMITTED_ON: APIDATA?.TEXT_SUBMITTED_ON || "Submitted on",

      TEXT_DELETED_EXPENSES: APIDATA?.TEXT_DELETED_EXPENSES || "Delete Expense",
      TEXT_CHOOSE_OPTION: APIDATA?.TEXT_CHOOSE_OPTION || "Please choose an option.",
      TEXT_CANCEL: APIDATA?.TEXT_CANCEL || "Cancel",
      TEXT_SUB_TOTAL: APIDATA?.TEXT_SUB_TOTAL || "Sub Total",
      TEXT_EXPENSES_REJECTED: APIDATA?.TEXT_EXPENSES_REJECTED || "This Expense has been rejected",
      TEXT_EXPENSES_APPROVED_AND_EDITED:
        APIDATA?.TEXT_EXPENSES__APPROVED_AND_EDITED ||
        "This Expense has been approved and cannot be edited."
    };
  },
  QualityControl: (APIDATA) => {
    return {
      TEXT_PROGRESS: APIDATA?.TEXT_PROGRESS || "Progress",
      TEXT_NO_QUALITY_JOBS: APIDATA?.TEXT_NO_QUALITY_JOBS || "No Quality Control Jobs."
    };
  },

  QualityControlDetails: (APIDATA) => {
    return {
      TEXT_PROGRESS_DETAILS: APIDATA?.TEXT_PROGRESS_DETAILS || "Progress",
      TEXT_SUBMITTED_DETAILS: APIDATA?.TEXT_SUBMITTED_DETAILS || "Submitted:",
      TEXT_DETAILS_DRAFT: APIDATA?.TEXT_DETAILS_DRAFT || "Draft:"
    };
  },
  QualityControlModal: (APIDATA) => {
    return {
      TEXT_SUBMITTED_DETAILS_MODAL: APIDATA?.TEXT_SUBMITTED_DETAILS_MODAL || "Submitted:",
      TEXT_DETAILS_DRAFT: APIDATA?.TEXT_DETAILS_DRAFT || "Draft:",
      TEXT_DETAILS_PASS: APIDATA?.TEXT_DETAILS_PASS || "Pass",
      TEXT_DETAILS_FAIL: APIDATA?.TEXT_DETAILS_FAIL || "Fail",
      TEXT_DETAILS_DONE: APIDATA?.TEXT_DETAILS_DONE || "Done",
      TEXT_DETAILS_INSPECTION:
        APIDATA?.TEXT_DETAILS_INSPECTION || "The inspection has not been submitted yet.",
      TEXT_DETAILS_ADD_PICTURE: APIDATA?.TEXT_DETAILS_ADD_PICTURE || "Add Picture",
      TEXT_DETAILS_COMPLETED_SIGNED_OFF:
        APIDATA?.TEXT_DETAILS_COMPLETED_SIGNED_OFF ||
        "All items must be completed and signed off before submission.",
      TEXT_SIGNATURE: APIDATA?.TEXT_SIGNATURE || "Signature",
      TEXT_DETAILS_SUBMIT: APIDATA?.TEXT_DETAILS_SUBMIT || "Submit",
      TEXT_DETAILS_NO_DATA: APIDATA?.TEXT_DETAILS_NO_DATA || "No Data",
      TEXT_MODAL_CLEAR: APIDATA?.TEXT_MODAL_CLEAR || "Clear",
      TEXT_MODAL_DISCARD: APIDATA?.TEXT_MODAL_DISCARD || "Discard",
      TEXT_SAVE_DRAFT: APIDATA?.TEXT_SAVE_DRAFT || "Save Draft",
      TEXT_WRITE_SOMETHING: APIDATA?.TEXT_WRITE_SOMETHING || "Write something",
      TEXT_REQUIRED: APIDATA?.TEXT_REQUIRED || "(required)"
    };
  },
  Actions: (APIDATA) => {
    return {
      TEXT_ACTIONS: APIDATA?.TEXT_ACTIONS || "Actions",
      TEXT_RECEIVED: APIDATA?.TEXT_RECEIVED || "Received",
      TEXT_SUBMITTED: APIDATA?.TEXT_SUBMITTED || "Submitted",
      TEXT_DUE: APIDATA?.TEXT_DUE || "Due",
      TEXT_NO_RECEIVED_ACTIONS:
        APIDATA?.TEXT_NO_RECEIVED_ACTIONS || "You do not have any received Actions.",
      TEXT_NO_SUBMITTED_ACTIONS:
        APIDATA?.TEXT_NO_SUBMITTED_ACTIONS || "You have not submitted any Actions."
    };
  },
  ActionDetails: (APIDATA) => {
    return {
      TEXT_CREATED_BY: APIDATA?.TEXT_CREATED_BY || "Created by",
      TEXT_CREATED_FOR: APIDATA?.TEXT_CREATED_FOR || "Created for",
      TEXT_DUE: APIDATA?.TEXT_DUE || "Due",
      TEXT_STATUS: APIDATA?.TEXT_STATUS || "Status",
      TEXT_UPDATE: APIDATA?.TEXT_UPDATE || "Update",
      TEXT_CREATED_ON: APIDATA?.TEXT_CREATED_ON || "Created on",
      TEXT_WRITE_COMMENT: APIDATA?.TEXT_WRITE_COMMENT || "Write a comment",
      TEXT_UPDATE_STATUS: APIDATA?.TEXT_UPDATE_STATUS || "Update Status",
      TEXT_INPROGRESS: APIDATA?.TEXT_INPROGRESS || "In Progress",
      TEXT_ONHOLD: APIDATA?.TEXT_ONHOLD || "On Hold",
      TEXT_COMPLETED: APIDATA?.TEXT_COMPLETED || "Completed"
    };
  },
  ClientTimesheet: (APIDATA) => {
    return {
      TEXT_MY_TIMESHEETS: APIDATA?.TEXT_MY_TIMESHEETS || "My Timesheets",
      TEXT_HOURS: APIDATA?.TEXT_HOURS || "Hours",
      TEXT_NOT_SUBMITTED_TIMESHEET:
        APIDATA?.TEXT_NOT_SUBMITTED_TIMESHEET || "You have not submitted any Timesheet yet.",
      TEXT_FOREMAN_CREATED_TITLE:
        APIDATA?.TEXT_FOREMAN_CREATED_TITLE || "Your foreman created the timesheet for your crew.",
      TEXT_ACTIVITIES: APIDATA?.TEXT_ACTIVITIES || "Activities",
      TEXT_EMPLOYEES: APIDATA?.TEXT_EMPLOYEES || "Employees",
      TEXT_JOBS: APIDATA?.TEXT_JOBS || "Jobs"
    };
  },
  ClientTimesheetAddModal: (APIDATA) => {
    return {
      TEXT_CREATE_NEW_TIMESHEET: APIDATA?.TEXT_CREATE_NEW_TIMESHEET || "Create a new Timesheet",
      TEXT_MANUAL: APIDATA?.TEXT_MANUAL || "Manual",
      TEXT_CLOCK_IN: APIDATA?.TEXT_CLOCK_IN || "Clock in",
      TEXT_OR: APIDATA?.TEXT_OR || "OR",
      TEXT_CREW_TIMESHEET: APIDATA?.TEXT_CREW_TIMESHEET || "Crew Timesheet",
      TEXT_MULTIPLE_EMPLOYEES: APIDATA?.TEXT_MULTIPLE_EMPLOYEES || "For multiple employees",
      TEXT_MY_TEMPLATES: APIDATA?.TEXT_MY_TEMPLATES || "My Templates",
      TEXT_NEW_TEMPLATE: APIDATA?.TEXT_NEW_TEMPLATE || "New Template",
      TEXT_NO_TEMPLATES:
        APIDATA?.TEXT_NO_TEMPLATES ||
        "Use templates to quickly create new Crew Timesheets with the same Job, Activities, and Employees.",
      TEXT_ACTIVITIES: APIDATA?.TEXT_ACTIVITIES || "Activities",
      TEXT_EMPLOYEE: APIDATA?.TEXT_EMPLOYEE || "Employees",
      TEXT_TEMPLATE_EDIT: APIDATA?.TEXT_TEMPLATE_EDIT || "Edit",
      TEXT_DUPLICATE_TEMPLATE: APIDATA?.TEXT_DUPLICATE_TEMPLATE || "Duplicate Template",
      TEXT_DELETE: APIDATA?.TEXT_DELETE || "Delete"
    };
  },
  SelectJobModal: (APIDATA) => {
    return {
      TEXT_SELECT_JOB_ACTIVITIES: APIDATA?.TEXT_SELECT_JOB_ACTIVITIES || "Select Job/Activities",
      TEXT_SORT_BY: APIDATA?.TEXT_SORT_BY || "Sort by",
      TEXT_NEAR_BY: APIDATA?.TEXT_NEAR_BY || "nearby",
      TEXT_RECENT: APIDATA?.TEXT_RECENT || "recent",
      BUTTON_NEXT: APIDATA?.BUTTON_NEXT || "Next",
      TEXT_SELECT_JOB: APIDATA?.TEXT_SELECT_JOB || "Select Job",
      TEXT_GEOLOCATION_NOT_SUPPORTED:
        APIDATA?.TEXT_GEOLOCATION_NOT_SUPPORTED || "Geolocation is not supported by your browser",
      TEXT_LOCATION_ACCESS_REQUIRED:
        APIDATA?.TEXT_LOCATION_ACCESS_REQUIRED ||
        "Location access is required for nearby sorting. Please enable location access in your browser settings.",
      TEXT_UNABLE_TO_ACCESS_LOCATION:
        APIDATA?.TEXT_UNABLE_TO_ACCESS_LOCATION ||
        "Unable to access your location. Please enable location services to use nearby sorting.",
      TEXT_NO_JOBS_FOUND: APIDATA?.TEXT_NO_JOBS_FOUND || "No Jobs Found"
    };
  },
  SelectJobActivitiesModal: (APIDATA) => {
    return {
      TEXT_SELECt_JOB_ACTIVITIES: APIDATA?.TEXT_SELECt_JOB_ACTIVITIES || "Select Job Activities",
      BUTTON_NEXT: APIDATA?.BUTTON_NEXT || "NEXT",
      TEXT_SEARCH_JOB_ACTIVITY: APIDATA?.TEXT_SEARCH_JOB_ACTIVITY || "Search for a job Activity",
      TEXT_NO_JOB_ACTIVITES_FOUND: APIDATA?.TEXT_NO_JOB_ACTIVITES_FOUND || "No Job Activities found"
    };
  },
  SelectJobEmployeesModal: (APIDATA) => {
    return {
      TEXT_SELECT_EMPLOYEES: APIDATA?.TEXT_SELECT_EMPLOYEES || "Select Employees",
      TEXT_SEARCH_EMPLOYEE: APIDATA?.TEXT_SEARCH_EMPLOYEE || "Search for an employee",
      BUTTON_NEXT: APIDATA?.BUTTON_NEXT || "NEXT",
      TEXT_NO_EMPLOYEE_FOUND: APIDATA?.TEXT_NO_EMPLOYEE_FOUND || "No Employees found",
      TEXT_NO_EMPLOYEES_SUPERVISED:
        APIDATA?.TEXT_NO_EMPLOYEES_SUPERVISED ||
        "Only employees assigned under your supervision will appear here. If someone is missing, please contact to"
    };
  },
  AddTimesheetModal: (APIDATA) => {
    return {
      TEXT_DATE: APIDATA?.TEXT_DATE || "Date",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_SEARCH_JOB: APIDATA?.TEXT_SEARCH_JOB || "Search for a job",
      TEXT_HOURS: APIDATA?.TEXT_HOURS || "Hours",
      TEXT_ADD_JOBS: APIDATA?.TEXT_ADD_JOBS || "ADD JOBS",
      TEXT_MILEAGE: APIDATA?.TEXT_MILEAGE || "Mileage",
      TEXT_IN: APIDATA?.TEXT_IN || "In",
      TEXT_OUT: APIDATA?.TEXT_OUT || "Out",
      PLACEHOLDER_SOMETHING: APIDATA?.PLACEHOLDER_SOMETHING || "Write something",
      BUTTON_SUBMIT: APIDATA?.BUTTON_SUBMIT || "SUBMIT",
      BUTTON_DELETE: APIDATA?.BUTTON_DELETE || "DELETE",
      TEXT_ACTIVITIES: APIDATA?.TEXT_ACTIVITIES || "Activities",
      TEXT_EMPLOYEE: APIDATA?.TEXT_EMPLOYEE || "Employees",
      TEXT_QTY: APIDATA?.TEXT_QTY || "Qty",
      TEXT_SELECT_ACTIVITIES: APIDATA?.TEXT_SELECT_ACTIVITIES || "Select Activities",
      TEXT_SELECT_EMPLOYEES: APIDATA?.TEXT_SELECT_EMPLOYEES || "Select Employees",
      TEXT_QUESTION_TIMESHEET:
        APIDATA?.TEXT_QUESTION_TIMESHEET || "How do you want to record details for this timesheet?",
      TEXT_MANUALLY_ENTER_HOURS: APIDATA?.TEXT_MANUALLY_ENTER_HOURS || "Manually enter hours",
      TEXT_EMPLOYEES_CLOCKIN_OUT:
        APIDATA?.TEXT_EMPLOYEES_CLOCKIN_OUT || "Have employees clock in and out",
      TEXT_TIMESHEET_TOTAL: APIDATA?.TEXT_TIMESHEET_TOTAL || "Timesheet Total",
      TEXT_MILEAGE_OPTIONAL: APIDATA?.TEXT_MILEAGE_OPTIONAL || "Mileage (Optional)",
      TEXT_NOTES: APIDATA?.TEXT_NOTES || "Notes",
      TEXT_SUGGESTION_TIMESHEET:
        APIDATA?.TEXT_SUGGESTION_TIMESHEET ||
        "Submitted Crew Timesheets cannot be edited. Employees on this Timesheet will receive a copy of their activities and logged hours",
      BUTTON_DELETE_TIMESHEET: APIDATA?.BUTTON_DELETE_TIMESHEET || "Delete Timesheet",
      BUTTON_NEXT: APIDATA?.BUTTON_NEXT || "NEXT",
      TEXT_LAST_UPDATED_AT: APIDATA?.TEXT_LAST_UPDATED_AT || "Last Updated at",
      TEXT_ACTIVITY_TOTAL: APIDATA?.TEXT_ACTIVITY_TOTAL || "Activity Total",
      TEXT_SUBMITTED_ON: APIDATA?.TEXT_SUBMITTED_ON || "Submitted on",
      TEXT_CLOCK_IN: APIDATA?.TEXT_CLOCK_IN || "Clock in",
      TEXT_CLOCK_OUT: APIDATA?.TEXT_CLOCK_OUT || "Clock Out",
      TEXT_INFORMATION_NECESSARY:
        APIDATA?.TEXT_INFORMATION_NECESSARY ||
        "Clock in and out to log your hours, and add any information necessary.",
      TEXT_FOREMAN: APIDATA?.TEXT_FOREMAN || "Foreman",
      TEXT_YOUR_FOREMAN_TEXT: APIDATA?.TEXT_YOUR_FOREMAN_TEXT || "Your Foreman",
      TEXT_CREATED_TIMESHEET_FOR_YOU:
        APIDATA?.TEXT_CREATED_TIMESHEET_FOR_YOU || "Created this Timesheet for you.",
      TEXT_DETAIL_MODAL_KM: APIDATA?.TEXT_DETAIL_MODAL_KM || "Km",
      TEXT_MI: APIDATA?.TEXT_MI || "Mi",
      TEXT_TODAY: APIDATA?.TEXT_TODAY || "(Today)",

      DISACRD_CHANGES: APIDATA?.DISACRD_CHANGES || "Discard",
      TEXT_WILL_BE_LOST:
        APIDATA?.TEXT_WILL_BE_LOST ||
        "Are you sure you want to discard your changes? Unsaved changes will be lost.",
      BUTTON_DISCARD: APIDATA?.BUTTON_DISCARD || "Discard",
      BUTTON_SAVE: APIDATA?.BUTTON_SAVE || "Save"
    };
  },
  Signature: (APIDATA) => {
    return {
      TEXT_SIGNATURE: APIDATA?.TEXT_SIGNATURE || "Signature",
      TEXT_CLOSE: APIDATA?.TEXT_CLOSE || "Close"
    };
  },
  ConfirmModal: (APIDATA) => {
    return {
      TEXT_EMP_CLOCKED_IN: APIDATA?.TEXT_SIGNATURE_2 || "There are still Employees clocked in.",
      TEXT_SUBMITTING_AUTOMATTCALLY_CLOCK_OUT_EMP:
        APIDATA?.TEXT_SUBMITTING_AUTOMATTCALLY_CLOCK_OUT_EMP ||
        "Submitting now will automatically clock out all Employees.",
      TEXT_SUBMITTED_TIMESHEET_CANNOT_EDITED:
        APIDATA?.TEXT_SUBMITTED_TIMESHEET_CANNOT_EDITED ||
        "Submitted Timesheets can not be edited.",
      TEXT_SUBMIT: APIDATA?.TEXT_SUBMIT || "Submit",
      BUTTON_OK: APIDATA?.BUTTON_OK || "OK",
      TEXT_GO_BACK: APIDATA?.TEXT_GO_BACK || "Go Back",
      BUTTON_DELETE: APIDATA?.BUTTON_DELETE || "DELETE", //n
      TEXT_ADD_JOBS: APIDATA?.TEXT_ADD_JOBS || "Add Jobs", //n
      TEXT_DELETE_HEADER:
        APIDATA?.TEXT_DELETE_HEADER || "The hours you logged will also be deleted.", //n
      TEXT_JOB_DELETE_TITLE:
        APIDATA?.TEXT_JOB_DELETE_TITLE || "Are you sure you want to delete this Job?",
      TEXT_CANNOT_BE_UNDONE: APIDATA?.TEXT_CANNOT_BE_UNDONE || "This cannot be undone.",
      TEXT_CONTINUE: APIDATA?.TEXT_CONTINUE || "Continue",
      CLOCK_OUT_CURRENT_JOB:
        APIDATA?.CLOCK_OUT_CURRENT_JOB || "You will be clocked out of your current Job."
    };
  },
  DeletConfirmModal: (APIDATA) => {
    return {
      TEXT_ACTION_BE_UNDONE: APIDATA?.TEXT_ACTION_BE_UNDONE || "This action cannot be undone.",
      TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET:
        APIDATA?.TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET ||
        "Are you sure you want to delete this Timesheet?",
      TEXT_GO_BACK: APIDATA?.TEXT_GO_BACK || "Go Back",
      TEXT_DELETE: APIDATA?.TEXT_DELETE || "Delete"
    };
  },
  CrewTemplateForm: (APIDATA) => {
    return {
      TEXT_TEMPLATE_NAME: APIDATA?.TEXT_TEMPLATE_NAME || "Template Name",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_SEARCH_JOB: APIDATA?.TEXT_SEARCH_JOB || "Search for a job",
      TEXT_ACTIVITIES: APIDATA?.TEXT_ACTIVITIES || "Activities",
      TEXT_SELECT_ACTIVITIES: APIDATA?.TEXT_SELECT_ACTIVITIES || "Select activities",
      TEXT_EMPLOYEES: APIDATA?.TEXT_EMPLOYEES || "Employees",
      TEXT_SELECT_EMPLOYEES: APIDATA?.TEXT_SELECT_EMPLOYEES || "Select Employees",
      TEXT_SAVE: APIDATA?.TEXT_SAVE || "Save",
      TEXT_NAME_PALCEHOLDER: APIDATA?.TEXT_NAME_PALCEHOLDER || "Enter a name (required)"
    };
  },
  CrewTemplateView: (APIDATA) => {
    return {
      TEXT_TEMPLATE_EDIT: APIDATA?.TEXT_TEMPLATE_EDIT || "Edit",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_ACTIVITIES: APIDATA?.TEXT_ACTIVITIES || "Activities",
      TEXT_EMPLOYEES: APIDATA?.TEXT_EMPLOYEES || "Employees",
      TEXT_CREATE_TIMESHEET: APIDATA?.TEXT_CREATE_TIMESHEET || "Create Timesheet",
      TEXT_DELETE_TIMESHEET: APIDATA?.TEXT_DELETE_TIMESHEET || "Delete Template",
      TEXT_DELETE_TEMPLATE:
        APIDATA?.TEXT_DELETE_TEMPLATE || "Are you sure want to delete this Template?"
    };
  },
  ReviewTimesheet: (APIDATA) => {
    return {
      TEXT_REVIEW_TIMESHEET: APIDATA?.TEXT_REVIEW_TIMESHEET || "Review Timesheet",
      TEXT_MILEAGE: APIDATA?.TEXT_MILEAGE || "Mileage",
      TEXT_ACTIVITY: APIDATA?.TEXT_ACTIVITY || "Activity",
      TEXT_SUBMIT: APIDATA?.TEXT_SUBMIT || "Submit",
      TEXT_TOTAL: APIDATA?.TEXT_TOTAL || "Total",
      TEXT_TIME_HOURS: APIDATA?.TEXT_TIME_HOURS || "Time (h)",
      TEXT_SIGNATURE: APIDATA?.TEXT_SIGNATURE || "Signature",
      TEXT_CLEAR: APIDATA?.TEXT_CLEAR || "Clear",
      TEXT_NOT_INJURED_TODAY: APIDATA?.TEXT_NOT_INJURED_TODAY || "I was not injured today"
    };
  },
  ClientSaftyIncident: (APIDATA) => {
    return {
      TEXT_CLIENT_NOTIFIELD: APIDATA?.TEXT_CLIENT_NOTIFIELD || "Client Notified",
      TEXT_YOU_HAVE_NOT_SUBMITTED_ANY_INCIDENTS_YET:
        APIDATA?.TEXT_YOU_HAVE_NOT_SUBMITTED_ANY_INCIDENTS_YET ||
        "You have not submitted any incidents yet."
    };
  },
  ClientSaftyIncidentAddModal: (APIDATA) => {
    return {
      TEXT_DATE: APIDATA?.TEXT_DATE || "Date",
      TEXT_TIME: APIDATA?.TEXT_DATE || "Time",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_SEAECH_FOR_JOB: APIDATA?.TEXT_JOB || "Search for a Job",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_HAPPENED_IMMEDIATE_ACTION:
        APIDATA?.TEXT_HAPPENED_IMMEDIATE_ACTION ||
        "(What happened, immediate actions, first aid administered, client action)",
      BTN_SUBMIT: APIDATA?.BTN_SUBMIT || "Submit",
      CLIENT_NOTIFIELD: APIDATA?.CLIENT_NOTIFIELD || "Client Notified"
    };
  },
  ClientSaftyIncidentViewModal: (APIDATA) => {
    return {
      TEXT_DATE: APIDATA?.TEXT_DATE || "Date:",
      TEXT_TIME: APIDATA?.TEXT_TIME || "Time:",
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job:",
      TEXT_CLIENT_NOTIFIELD: APIDATA?.TEXT_CLIENT_NOTIFIELD || "Client Notified"
    };
  },

  JobsListing: (APIDATA) => {
    return {
      TEXT_CLOCK_IN: APIDATA?.TEXT_CLOCK_IN || "Clock in",
      TEXT_OUT: APIDATA?.TEXT_OUT || "Out",
      TEXT_IN: APIDATA?.TEXT_IN || "In",
      TEXT_CLOCK_OUT: APIDATA?.TEXT_CLOCK_OUT || "Clock Out",
      TEXT_HOURS: APIDATA?.TEXT_HOURS || "Hours",
      TEXT_MILEAGE: APIDATA?.TEXT_MILEAGE || "Mileage",
      TEXT_JOBPOSTING_OPTIONAL: APIDATA?.TEXT_JOBPOSTING_OPTIONAL || "0.0 (optional)", //n
      TEXT_DETAIL_MODAL_KM: APIDATA?.TEXT_DETAIL_MODAL_KM || "Km",
      TEXT_MI: APIDATA?.TEXT_MI || "Mi",
      TEXT_WRITE_SOMETHING: APIDATA?.TEXT_WRITE_SOMETHING || "Write something"
    };
  },
  ClientTimesheetManualComponent: (APIDATA) => {
    return {
      TEXT_CREATE_NEW_TIMESHEET: APIDATA?.TEXT_CREATE_NEW_TIMESHEET || "Create a new Timesheet",
      TEXT_ADD_JOBS: APIDATA?.TEXT_ADD_JOBS || "ADD JOBS",
      BTN_SUBMIT: APIDATA?.BTN_SUBMIT || "Submit",
      TEXT_SUBMIT_MODAL_DESC:
        APIDATA?.TEXT_SUBMIT_MODAL_DESC || "Submitted Timesheets cannot be edited.",
      TEXT_UNSAVE_CHANGES: APIDATA?.TEXT_UNSAVE_CHANGES || "Your changes have not been saved yet.",
      TEXT_LEAVE: APIDATA?.TEXT_LEAVE || "Leave",
      TEXT_DATE: APIDATA?.TEXT_DATE || "Date"
    };
  },
  JobsListingManual: (APIDATA) => {
    return {
      TEXT_HOURS: APIDATA?.TEXT_HOURS || "Hours",
      TEXT_MILEAGE: APIDATA?.TEXT_MILEAGE || "Mileage",
      TEXT_DETAIL_MODAL_KM: APIDATA?.TEXT_DETAIL_MODAL_KM || "Km",
      TEXT_MI: APIDATA?.TEXT_MI || "Mi",
      TEXT_WRITE_SOMETHING: APIDATA?.TEXT_WRITE_SOMETHING || "Write something"
    };
  },
  SelectJobsManual: (APIDATA) => {
    return {
      TEXT_GEOLOCATION_NOT_SUPPORTED:
        APIDATA?.TEXT_GEOLOCATION_NOT_SUPPORTED || "Geolocation is not supported by your browser", //n
      TEXT_LOCATION_ACCESS_REQUIRED:
        APIDATA?.TEXT_LOCATION_ACCESS_REQUIRED ||
        "Location access is required for nearby sorting. Please enable location access in your browser settings.", //n
      TEXT_UNABLE_TO_ACCESS_LOCATION:
        APIDATA?.TEXT_UNABLE_TO_ACCESS_LOCATION ||
        "Unable to access your location. Please enable location services to use nearby sorting.",
      TEXT_SELECT_JOB_ACTIVITIES: APIDATA?.TEXT_SELECT_JOB_ACTIVITIES || "Select Job/Activities",
      TEXT_SORT_BY: APIDATA.TEXT_SORT_BY || "Sort by",
      TEXT_NEAR_BY: APIDATA?.TEXT_NEAR_BY || "nearby",
      TEXT_RECENT: APIDATA?.TEXT_RECENT || "recent",
      BUTTON_NEXT: APIDATA?.BUTTON_NEXT || "Next",
      TEXT_NO_JOBS_FOUND: APIDATA?.TEXT_NO_JOBS_FOUND || "No Jobs Found"
    };
  },
  SaveTemplateModal: (APIDATA) => {
    return {
      TEXT_NO_THANKS: APIDATA?.TEXT_NO_THANKS || "No Thanks",
      TEXT_TEMPLATE_SAVE_BTN: APIDATA?.TEXT_TEMPLATE_SAVE_BTN || "Save as Template",
      TEXT_SAVE_TEMPLATE_DESC:
        APIDATA?.TEXT_SAVE_TEMPLATE_DESC ||
        "Save this timesheet as a template to quickly create new Timesheets with the same job, Activities and Crew.",
      TEXT_SAVE_TEMPLATE: APIDATA?.TEXT_SAVE_TEMPLATE || "Save as Template ?"
    };
  },
  ClientTimesheetViewIndividual: (APIDATA) => {
    return {
      TEXT_SUBMITTED_ON: APIDATA?.TEXT_SUBMITTED_ON || "Submitted on",
      TEXT_NO_TIMESHEET_DATA: APIDATA?.TEXT_NO_TIMESHEET_DATA || "No timesheet data available",
      TEXT_IN_REVIEW: APIDATA?.TEXT_IN_REVIEW || "In Review",
      TEXT_APPROVED: APIDATA?.TEXT_APPROVED || "Approved",
      TEXT_REJECTED: APIDATA?.TEXT_REJECTED || "Rejected",
      TEXT_UNKNOWN: APIDATA?.TEXT_UNKNOWN || "Unknown",
      TEXT_MILEAGE: APIDATA?.TEXT_MILEAGE || "Mileage",
      TEXT_HOURS: APIDATA?.TEXT_HOURS || "Hours"
    };
  },
  ClientExpenses: (APIDATA) => {
    return {
      TEXT_NO_EXPENSE: APIDATA?.TEXT_NO_EXPENSE || "You have not submitted any Expenses yet."
    };
  },
  ClientInspections: (APIDATA) => {
    return {
      //Inspections.jsx
      TEXT_NO_INSPECTION_FORM_AVAILABLE:
        APIDATA?.TEXT_NO_INSPECTION_FORM_AVAILABLE || "No inspection forms available",
      //JobList.jsx
      TEXT_SELECT_JOBS: APIDATA?.TEXT_SELECT_JOBS || "Select Jobs",
      TEXT_SEARCH_FOR_A_JOB: APIDATA?.TEXT_SEARCH_FOR_A_JOB || "Search for a job...",
      TEXT_NO_JOBS_FOUND: APIDATA?.TEXT_NO_JOBS_FOUND || "No Jobs Found", //
      TEXT_SELECT: APIDATA?.TEXT_SELECT || "Select",
      //NewInspectionModal.jsx
      TEXT_NEW_INSPECTION: APIDATA?.TEXT_NEW_INSPECTION || "New Inspection", //
      //SaveDraftModal.jsx
      TEXT_DRAFT_OR_DISCARD: APIDATA?.TEXT_DRAFT_OR_DISCARD || "Save Draft or Discard?",
      TEXT_DO_YOU_WANT_TO_SAVE_YOUR_CHANGES:
        APIDATA?.TEXT_DO_YOU_WANT_TO_SAVE_YOUR_CHANGES ||
        "Do you want to save your changes as a draft or discard them?",
      TEXT_MODAL_DISCARD: APIDATA?.TEXT_MODAL_DISCARD || "Discard", //
      TEXT_MODAL_SAVE_AS_DRAFT: APIDATA?.TEXT_MODAL_SAVE_AS_DRAFT || "Save as Draft",
      //SectionViewModal.jsx
      TEXT_NO_ANSWER_PROVIDED: APIDATA?.TEXT_NO_ANSWER_PROVIDED || "No answer provided",
      TEXT_PLEASE_TYPE_YOUR_ANS:
        APIDATA?.TEXT_PLEASE_TYPE_YOUR_ANS || "Please type your answer here...",
      TEXT_SELECT_A_DATE: APIDATA?.TEXT_SELECT_A_DATE || "Select a Date",
      TEXT_SELECT_A_START_DATE: APIDATA?.TEXT_SELECT_A_START_DATE || "Select a Start Date",
      TEXT_SELECT_END_DATE: APIDATA?.TEXT_SELECT_END_DATE || "Select a End Date",
      TEXT_AFTER_ADDING_YOUR_SIGNATURE:
        APIDATA?.TEXT_AFTER_ADDING_YOUR_SIGNATURE ||
        "After adding your signature, please make sure to tap the 'Save' button. You can reset it anytime after saving.",
      TEXT_SAVE: APIDATA?.TEXT_SAVE || "Save", //
      TEXT_CLEAR: APIDATA?.TEXT_CLEAR || "Clear", //
      BUTTON_RESET: APIDATA?.BUTTON_RESET || "Reset",
      TEXT_UNSUPPORTED_FIELD_TYPE: APIDATA?.TEXT_UNSUPPORTED_FIELD_TYPE || "Unsupported field type",
      TEXT_NO_QUESTIONS_AVAILABLE:
        APIDATA?.TEXT_NO_QUESTIONS_AVAILABLE || "No questions available for this section.",
      TEXT_NO_SEC_NO_QUE_AVAILABLE:
        APIDATA?.TEXT_NO_SEC_NO_QUE_AVAILABLE ||
        "No sections and no questions are available for this form.",
      TEXT_SUBMIT: APIDATA?.TEXT_SUBMIT || "Submit" //
    };
  },
  ClientWorkPackageView: (APIDATA) => {
    return {
      TEXT_ACTIVITIES: APIDATA?.TEXT_ACTIVITIES || "Activities",
      TEXT_SELECT_ACTIVITY_INSTRUCTION:
        APIDATA?.TEXT_SELECT_ACTIVITY_INSTRUCTION ||
        "Select the activity you are currently working on to track your time:",
      TEXT_NO_DESCRIPTION_AVAILABLE:
        APIDATA?.TEXT_NO_DESCRIPTION_AVAILABLE || "No description available",
      TEXT_PROCESSING: APIDATA?.TEXT_PROCESSING || "Processing...",
      TEXT_LOGOUT: APIDATA?.TEXT_LOGOUT || "Logout",
      TEXT_PACKAGE_FILES: APIDATA?.TEXT_PACKAGE_FILES || "Package Files",
      TEXT_UNKNOWN_FILE: APIDATA?.TEXT_UNKNOWN_FILE || "Unknown File",
      TEXT_UNKNOWN_TYPE: APIDATA?.TEXT_UNKNOWN_TYPE || "Unknown Type",
      TEXT_NO_FILES_AVAILABLE:
        APIDATA?.TEXT_NO_FILES_AVAILABLE || "No files available for this work package",
      TEXT_ONGOING_TIMESHEET_DETECTED:
        APIDATA?.TEXT_ONGOING_TIMESHEET_DETECTED || "Ongoing Timesheet Detected",
      TEXT_ONGOING_TIMESHEET_MESSAGE:
        APIDATA?.TEXT_ONGOING_TIMESHEET_MESSAGE ||
        "You have ongoing timesheet(s) in other work package(s). Continuing will automatically clock out these timesheets and start tracking time for this activity.",
      TEXT_DO_YOU_WANT_TO_CONTINUE:
        APIDATA?.TEXT_DO_YOU_WANT_TO_CONTINUE || "Do you want to continue?",
      TEXT_CANCEL: APIDATA?.TEXT_CANCEL || "Cancel",
      TEXT_CONTINUE: APIDATA?.TEXT_CONTINUE || "Continue"
    };
  },

  ClientWorkPackage: (APIDATA) => {
    return {
      TEXT_SCAN_QR_CODE: APIDATA?.TEXT_SCAN_QR_CODE || "Scan QR code",
      TEXT_NO_JOBS_AVAILABLE: APIDATA?.TEXT_NO_JOBS_AVAILABLE || "No jobs available",
      TEXT_UNKNOWN_JOB: APIDATA?.TEXT_UNKNOWN_JOB || "Unknown Job",
      TEXT_NO_WORK_PACKAGES_AVAILABLE:
        APIDATA?.TEXT_NO_WORK_PACKAGES_AVAILABLE || "No work packages available for this job"
    };
  },

  ClientWorkPackageInfoModal: (APIDATA) => {
    return {
      TEXT_JOB: APIDATA?.TEXT_JOB || "Job",
      TEXT_FOREMAN: APIDATA?.TEXT_FOREMAN || "Foreman",
      TEXT_CREW_SIZE: APIDATA?.TEXT_CREW_SIZE || "Crew Size",
      TEXT_MEASURED_AREA: APIDATA?.TEXT_MEASURED_AREA || "Measured Area",
      TEXT_RATE_OF_MEASURE: APIDATA?.TEXT_RATE_OF_MEASURE || "Rate of Measure",
      TEXT_PLANNED_START_DATE: APIDATA?.TEXT_PLANNED_START_DATE || "Planned Start Date",
      TEXT_PLANNED_END_DATE: APIDATA?.TEXT_PLANNED_END_DATE || "Planned End Date",
      TEXT_DESCRIPTION: APIDATA?.TEXT_DESCRIPTION || "Description",
      TEXT_ITEMS: APIDATA?.TEXT_ITEMS || "Items"
    };
  }
};

export { ClientEnglishFallback };
